import { A11yModule } from '@angular/cdk/a11y';
import { AsyncPipe, NgClass } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonsModule } from 'shared-components/buttons';
import { IconComponent } from 'shared-components/icon';
import { OptionalAsyncPipe } from 'shared-components/optional-async';

import { components, publicComponents } from './components';
import { SnackbarsComponent } from './design-system/snackbars.component';

@NgModule({
  declarations: [
    ...components,
    SnackbarsComponent,
  ],
  imports: [
    A11yModule,
    AsyncPipe,
    NgClass,
    ButtonsModule,
    IconComponent,
    OptionalAsyncPipe,
  ],
  exports: [
    ...publicComponents,
    SnackbarsComponent,
  ],
})
export class SnackbarModule { }
